import "core-js/modules/es.array.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "file-upload is-light"
};
const _hoisted_2 = {
  class: "file-upload__body"
};
const _hoisted_3 = {
  class: "textarea"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "qh-icon-add"
}, null, -1);
const _hoisted_5 = {
  class: "bt-file-menu"
};
const _hoisted_6 = {
  key: 1,
  class: "textarea__tips"
};
const _hoisted_7 = {
  key: 1,
  class: "detect-compatibility"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "当前设备", -1);
const _hoisted_9 = {
  class: "cover"
};
const _hoisted_10 = {
  class: "pop-loading"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-loading"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "正在解析中", -1);
const _hoisted_13 = ["src"];
import { ref, computed, onMounted, watch } from 'vue';
import { checkValidLink, bytesToSize, getThunderLink, newToast } from '@remote/utils';
import { isIOS, MAX_URL_ADD_NUM } from '@remote/constant';
import PathChoicePop from '@remote/components/PathChoicePop.vue';
import '@remote/assets/css/upload.scss';
import copy from 'clipboard-copy';
import BTDecode from '@xunlei/bencode-worker';
import { IconPageLeft } from '@xunlei/thunder-icon-vue';
import DeviceIndicator from '@remote/components/DeviceIndicator.vue';
import { openDeviceList, openDialogCommon, openPopBTChoiceNew, openPopMenu, openPopSelectFile } from '@remote/utils/dialog';
import { store } from '@remote/store';
import router from '@remote/router';
import { stat } from '@remote/utils/stat';
import { useEnvStore } from '@remote/store/env';
import { useDeviceStore } from '@remote/store/device';
import { fixLink } from '@shared/utils/download';
import { isIOSNative, sleep } from '@xunlei/universal-native-api';
import { useToggle } from '@shared/composable/base';
import Shortcut from '@remote/assets/img/shortcut.png';
import { platformPath } from '@remote/platform';
import PageHeader from '@remote/components/PageHeader.vue';
// data
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const uploadUrls = ref('');
    const error = ref('');
    const isLoading = ref(false);
    const isSupportBEncode = ref(true);
    const urls = ref([]);
    const hasTaskLink = ref(false);
    const uploadInput = ref(null);
    const envStore = useEnvStore();
    const errorHint = {
      LIMIT_EXCEED: `最多支持同时添加${MAX_URL_ADD_NUM}个链接`,
      INVALID_LINK: '请输入正确的链接地址',
      OPERATION_FAILED: '操作未成功，请稍后重试',
      INVALID_BT: '请选择正确的bt文件'
    };
    // computed
    const createFrom = computed(() => {
      return store.state.createFrom;
    });
    const visiblePathChoose = computed(() => {
      return store.state.visiblePathChoose;
    });
    const curDeviceRunner = computed(() => {
      return store.state.curDeviceRunner;
    });
    const pathFolderName = computed(() => {
      return store.state.pathFolderName;
    });
    const runnerPath = computed(() => {
      return store.getters.runnerPath;
    });
    const isVip = computed(() => {
      return store.getters.isVip;
    });
    const showHeader = computed(() => {
      return store.getters.showHeader;
    });
    // watch接口返回的downloads字段
    const downloadsPath = computed(() => {
      var _store$state$deviceIn, _store$state$deviceIn2;
      return (_store$state$deviceIn = (_store$state$deviceIn2 = store.state.deviceInfoWatchData) === null || _store$state$deviceIn2 === void 0 ? void 0 : _store$state$deviceIn2.downloads) !== null && _store$state$deviceIn !== void 0 ? _store$state$deviceIn : [];
    });
    const currentDownloadPath = computed(() => {
      let realPath = '';
      if (pathFolderName.value) {
        // 手动选择的路径
        realPath = pathFolderName.value;
      } else {
        // 默认路径
        realPath = runnerPath.value.path;
      }
      return realPath;
    });
    const showUploadBT = computed(() => {
      var _curDeviceRunner$valu;
      if (!((_curDeviceRunner$valu = curDeviceRunner.value) !== null && _curDeviceRunner$valu !== void 0 && (_curDeviceRunner$valu = _curDeviceRunner$valu.params) !== null && _curDeviceRunner$valu !== void 0 && _curDeviceRunner$valu.platform)) {
        return false;
      }
      return true;
      // return UploadBTPlatforms.includes(curDeviceRunner.value?.params?.platform)
    });
    /**
     * 目标下载路径，对diskList中的path进行匹配
     */
    const targetDownloadPathDiskSpace = computed(() => {
      const path = currentDownloadPath.value;
      const matchPath = downloadsPath.value.filter(i => typeof i.path === 'string') // for robust
      .filter(i => path.indexOf(i.path) > -1);
      if (matchPath.length === 0) {
        return downloadsPath.value[0]; // 兜底
      }

      const maximumMatchPath = matchPath.reduce((prev, curr) => {
        return prev.path.length > curr.path.length ? prev : curr; // 上面matchPath的逻辑保证了这里的值一定不会是undefined
      });

      return maximumMatchPath;
    });
    const diskLeftSize = computed(() => {
      var _targetDownloadPathDi, _targetDownloadPathDi2, _targetDownloadPathDi3, _targetDownloadPathDi4;
      return ((_targetDownloadPathDi = (_targetDownloadPathDi2 = targetDownloadPathDiskSpace.value) === null || _targetDownloadPathDi2 === void 0 ? void 0 : _targetDownloadPathDi2.limit) !== null && _targetDownloadPathDi !== void 0 ? _targetDownloadPathDi : 0) - ((_targetDownloadPathDi3 = (_targetDownloadPathDi4 = targetDownloadPathDiskSpace.value) === null || _targetDownloadPathDi4 === void 0 ? void 0 : _targetDownloadPathDi4.usage) !== null && _targetDownloadPathDi3 !== void 0 ? _targetDownloadPathDi3 : 0);
    });
    // methods
    const onDeviceListClick = async () => {
      stat({
        action: 'addurl_change_device_button_click'
      });
      await openDeviceList({
        canRemoveDevice: false,
        actionFrom: 'addurl_panel'
      });
    };
    const {
      is: isBTFileMenuShow,
      toggle: toggleBTFileMenuShow
    } = useToggle({
      defaultIs: false
    });
    const BTMenuShowHandler = () => {
      toggleBTFileMenuShow(false);
    };
    watch(isBTFileMenuShow, val => {
      if (val) {
        setTimeout(() => {
          document.addEventListener('click', BTMenuShowHandler);
        }, 0);
      } else {
        document.removeEventListener('click', BTMenuShowHandler);
      }
    });
    const deviceStore = useDeviceStore();
    const handleUploadBT = () => {
      if (!isSupportBEncode.value) {
        newToast({
          type: 'error',
          message: '当前浏览器版本过低，无法使用本地BT文件解析功能'
        });
        return;
      }
      if (uploadInput.value) {
        uploadInput.value.click();
      }
    };
    /**
     * Taken from
     * https://stackoverflow.com/questions/62954570/javascript-feature-detect-module-support-for-web-workers
     * The WorkerType enum can only be one of "classic" or "module".
     * If an implementation checks this param it's because they support module.
     */
    const checkWebWorkerCompatibility = () => {
      let supports = false;
      const tester = {
        // @ts-ignore
        get type() {
          supports = true;
        }
      };
      try {
        // We use "blob://" as url to avoid an useless network request.
        // This will either throw in Chrome
        // either fire an error event in Firefox
        // which is perfect since
        // we don't need the worker to actually start,
        // checking for the type of the script is done before trying to load it.
        // @ts-ignore
        const worker = new Worker('blob://', tester);
      } finally {
        // eslint-disable-next-line no-unsafe-finally
        return supports;
      }
    };
    const handleBack = () => {
      // console.log('====== handleBack')
      // 因为有参数删除，back又会把参数带上
      router.replace({
        path: '/home/',
        query: router.currentRoute.value.query
      });
      uploadUrls.value = '';
    };
    const isDownloadAvailable = computed(() => {
      return store.getters.isDownloadAvailable;
    });
    const download = async taskParams => {
      try {
        for (const param of taskParams !== null && taskParams !== void 0 ? taskParams : []) {
          var _deviceStore$currentD;
          await ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.deviceFetch('drive/v1/task', {
            method: 'POST',
            data: {
              ...param
            }
          }));
        }
      } catch (error) {
        if (error.error === 'task_daily_create_limit' && store.getters.showVip) {
          store.commit('pop', {
            show: true,
            title: '今日下载额度已用完',
            tip: '非会员每日可免费创建3个下载任务，会员不限任务数（白金/超会均可）',
            okTxt: '开通会员',
            type: 'vip'
          });
        } else {
          store.commit('toast', error.error_description || '创建任务失败');
        }
        return;
      }
      store.commit('update', {
        taskType: 'ing'
      });
      newToast({
        type: 'success',
        message: '任务创建成功'
      });
      setTimeout(() => store.dispatch('getTasks', {
        isReplay: true
      }), 2000);
      if ((taskParams !== null && taskParams !== void 0 ? taskParams : []).length >= 1) {
        // console.log('handleBack')
        setTimeout(() => {
          handleBack();
        }, 500);
      }
    };
    const viewDuplicateTasks = async taskItem => {
      const taskType = taskItem.phase === 'PHASE_TYPE_COMPLETE' ? 'done' : 'ing';
      // 切换到对应的tab和选中对应任务
      store.commit('update', {
        selects: [],
        taskType
      });
      // 拉取新的任务列表
      store.dispatch('getTasks');
      // 回到home
      // console.log('====== viewDuplicateTasks back')
      await sleep(500);
      router.back();
      setTimeout(() => {
        // console.log('====== viewDuplicateTasks replace')
        router.replace({
          name: 'home',
          query: {
            ...router.currentRoute.value.query
          }
        });
      }, 500);
    };
    /**
     * 检查是否为重复任务
     * @param existedTask 已存在的任务
     * @param newTasks 新任务
     * @returns {boolean} false为不重复/继续创建下载任务; true为中断流程
     */
    const checkDuplicateTask = async (existedTask, newTasks) => {
      for (const taskItem of (_existedTask$tasks = existedTask.tasks) !== null && _existedTask$tasks !== void 0 ? _existedTask$tasks : []) {
        var _existedTask$tasks;
        for (const downloadItem of newTasks !== null && newTasks !== void 0 ? newTasks : []) {
          var _taskItem$params;
          // console.log(taskItem, downloadItem, existedTask, newTasks)
          if (taskItem.name === downloadItem.file_name || ((_taskItem$params = taskItem.params) === null || _taskItem$params === void 0 ? void 0 : _taskItem$params.url) === downloadItem.params.url) {
            const res = await openDialogCommon({
              title: '任务已存在',
              body: '当前任务已存在，继续下载将创建一个新任务',
              button: [{
                text: '下载',
                value: 'download'
              }, {
                text: '查看',
                value: 'check'
              }]
            });
            // console.log('任务已存在', res)
            if ((res === null || res === void 0 ? void 0 : res.result) === 'check') {
              viewDuplicateTasks(taskItem);
              return true;
            }
            return false;
          }
        }
      }
      return false;
    };
    const checkDiskSizeAvailable = async newTasks => {
      console.log('检查磁盘空间, 新任务：', newTasks);
      const totalSize = (newTasks !== null && newTasks !== void 0 ? newTasks : []).reduce((pre, cur) => {
        return pre + cur.file_size;
      }, 0);
      // console.log('totalSize', totalSize, 'diskLeftSize', diskLeftSize.value)
      if (totalSize > diskLeftSize.value) {
        isLoading.value = false;
        await openDialogCommon({
          title: '剩余空间不足',
          body: `文件大小${bytesToSize(totalSize)}，剩余空间${bytesToSize(diskLeftSize.value)}`,
          center: true,
          button: [{
            text: '我知道了',
            value: 'ok'
          }]
        });
        return false;
      }
      return true;
    };
    /**
     * 通过检查能否获取到磁盘列表，来检查穿透可用性
     * 磁盘列表是通过穿透获取的
     */
    const checkProxyAvailable = async () => {
      var _deviceStore$currentD2;
      const currentDiskList = (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.deviceInfoRef.downloads;
      if (currentDiskList && Array.isArray(currentDiskList)) {
        return true;
      }
      await openDialogCommon({
        title: '无法获取磁盘大小',
        body: '无法获取磁盘剩余空间，请检查网络连接质量；如有下载中任务可先暂停后再重试；',
        center: true,
        button: [{
          text: '我知道了',
          value: 'ok'
        }]
      });
      return false;
    };
    const beforeDownload = async taskParams => {
      let res = await store.dispatch('getTasks', {
        getAll: true
      });
      if (!res) return false;
      const isProxyAvailable = await checkProxyAvailable();
      if (!isProxyAvailable) return false;
      const isDiskSizeAvailable = await checkDiskSizeAvailable(taskParams);
      if (!isDiskSizeAvailable) return false;
      const isTaskDuplicate = await checkDuplicateTask(res, taskParams);
      if (isTaskDuplicate) return false;
      download(taskParams);
      return true;
    };
    const downloadList = async params => {
      return await beforeDownload(params);
    };
    const onUpload = async () => {
      if (uploadUrls.value === '') return;
      // 这里其实不该判断是否为PC，但是产品给的这个文案太过specific，所以还是判断下
      if (curDeviceRunner.value.space === 'platform#pcxllite' && !isDownloadAvailable.value) {
        await openDialogCommon({
          title: '当前设备未开启远程下载功能',
          body: '当前设备未开启远程下载功能，无法创建下载任务，请切换设备。<br/>若需要下载至此设备，请在此设备上打开迅雷11（版本号大于11.4.1），在右上角的主菜单中找到远程下载功能并打开。',
          button: [{
            text: '我知道了',
            value: 'ok'
          }]
        });
        return;
      }
      if (hasTaskLink.value) {
        hasTaskLink.value = false;
        copy('');
      }
      stat({
        action: 'new_create_panel_click',
        data: {
          action_from: createFrom.value,
          click_id: 'download'
        }
      });
      let allUrls = uploadUrls.value.split('\n').filter(v => v && v.length > 0);
      allUrls = Array.from(new Set(allUrls)).map(url => fixLink(url));
      let newURLs = allUrls.map(v => v && getThunderLink(v));
      newURLs = newURLs.filter(v => v && checkValidLink(v));
      // console.log('uploadUrls.value', uploadUrls.value, 'newURLs', newURLs)
      if (newURLs.length === 0) {
        return error.value = errorHint.INVALID_LINK;
      }
      if (newURLs.length > 1 && !isVip.value) {
        return store.commit('toast', '非会员暂不支持批量添加下载链接');
      }
      if (newURLs.length > MAX_URL_ADD_NUM) {
        return error.value = errorHint.LIMIT_EXCEED;
      }
      if (isLoading.value) return;
      // isLoading.value = true
      // resolveResourceTree(newURLs)
      // const res: IResourceRes = await store.dispatch('getResource', newURLs.join('\n'))
      // // const res: IResourceRes = await getResource(newURLs.join('\n'))
      // console.log('IResourceRes', res)
      // const tree = res.list && resolveTaskTree(res.list.resources)
      // console.log('tree, ', tree)
      // if (res && res.list) {
      //   // v2.13 忽略meta中返回的错误
      //   // 这个服务会查中台有没有资源索引，在下载没有索引的资源的时候会直接报错。
      //   // @刘景超：应该忽略查不到索引应该也可以从源地址下载。
      //   // if (res.list.resources && res.list.resources.length === 1) {
      //   //   const metaInfo = res.list.resources[0].meta
      //   //   const IGNORE_ERROR_LIST = ['407:E_SHUB_INDEX_REQ_FAIL']
      //   //   const IGNORE_ERROR_LIST = ['408:E_SHUB_INDEX_REQ_FAIL']
      //   //   if (metaInfo.error && !IGNORE_ERROR_LIST.includes(metaInfo.error)) {
      //   //     isLoading.value = false
      //   //     return (error.value = errorHint.INVALID_LINK)
      //   //   }
      //   // }
      //   const newResources = res.list.resources
      //   linkStatus.value.err = allUrls.length - newResources.length
      //   linkStatus.value.invalid = newResources.reduce((pre, cur) => {
      //     return pre + (cur.meta.error ? 1 : 0)
      //   }, 0)
      //   linkStatus.value.ok = newResources.length - linkStatus.value.invalid
      //   console.log('newResources', newResources)
      //   console.log('linkStatus.value', linkStatus.value)
      //   resources.value = newResources
      //   urls.value = newURLs
      //   btTree.value = tree
      urls.value = newURLs;
      const params = await openPopBTChoiceNew({
        urls: urls.value,
        afterConfirm: downloadList
      });
    };
    const triggerResolveURL = url => {
      uploadUrls.value = url;
      if (uploadInput.value) {
        uploadInput.value.value = '';
      }
      onUpload();
    };
    // TODO: 旧版本设备兼容
    const resolveBTFromDevice = async () => {
      var _file$, _deviceStore$currentD3;
      const file = await openPopSelectFile({
        title: '选择BT文件',
        needWritable: false,
        withParams: ['withCategoryDiskMountPath', 'withCategoryHistoryDownloadPath'],
        theme: 'light',
        type: 'radio',
        maxChooseCount: 1,
        filter: {
          trashed: {
            eq: false
          },
          phase: {
            eq: 'PHASE_TYPE_COMPLETE'
          },
          mime_type: {
            prefix: ['folder', 'application/x-bittorrent']
          }
        },
        needFileSource: false,
        needCreateFolder: false,
        checkboxShowCondition: file => {
          return (file === null || file === void 0 ? void 0 : file.mime_type) === 'application/x-bittorrent' || (file === null || file === void 0 ? void 0 : file.file_extension) === '.torrent';
        },
        fileMapping: file => file,
        confirmCondition: chosenFiles => {
          return chosenFiles.filter(i => {
            var _i$mime_type;
            return (_i$mime_type = i.mime_type) === null || _i$mime_type === void 0 ? void 0 : _i$mime_type.startsWith('application/x-bittorrent');
          }).length > 0;
        }
      });
      const fileID = (_file$ = file[0]) === null || _file$ === void 0 ? void 0 : _file$.id;
      if (!fileID) {
        console.log('用户取消选择，或未获取到fileID', file);
        return;
      }
      // message({
      //   type: 'info',
      //   message: '解析中...',
      // })
      const result = await ((_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.proxyFetch('device/btinfo', {
        method: 'POST',
        params: {
          file_id: fileID
        }
      }));
      if (!(result !== null && result !== void 0 && result.url)) {
        console.warn('解析后未获取到url', result);
        newToast({
          type: 'error',
          message: '解析失败'
        });
        return;
      }
      triggerResolveURL(result.url);
    };
    // 解析磁力链接
    const resolveBtTask = async evt => {
      console.log('收到本地BT解析事件', evt.target.files);
      let file = evt.target.files[0];
      const fileName = file.name;
      if (fileName.substring(fileName.lastIndexOf('.')) !== '.torrent') return error.value = errorHint.INVALID_BT;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async e => {
        console.log('开始解析BT', e.target.result);
        try {
          const result = await BTDecode(e.target.result);
          console.log('BT解析结果', result);
          triggerResolveURL(result);
        } catch (error) {
          error.value = errorHint.INVALID_BT;
        }
      };
    };
    const openShortCutPage = (url = '') => {
      if (url) {
        if (isIOSNative) {
          const supportNavigatorClipboardAPI = navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
          openDialogCommon({
            title: '请复制下面链接后，于浏览器中打开',
            body: url,
            center: true,
            button: [{
              text: supportNavigatorClipboardAPI ? '复制并关闭' : '关闭',
              value: 'close'
            }]
          });
          if (supportNavigatorClipboardAPI) {
            navigator.clipboard.writeText(url);
          }
          return;
        }
        window.open(url, '_blank');
      }
    };
    const addShortcut = async () => {
      const URL_ADD_TO_NAS = 'https://www.icloud.com/shortcuts/f252a33c0e384d2b9383b9fee6a117a2';
      const URL_CLIPBOARD_TO_NAS = 'https://www.icloud.com/shortcuts/23887e1de924464f8ba0696103bcacd8';
      const result = await openPopMenu({
        options: ['从链接快速添加到NAS', '从剪切板添加到NAS', '取消'],
        themeClass: 'is-light'
      });
      if (result === '从链接快速添加到NAS') {
        openShortCutPage(URL_ADD_TO_NAS);
      }
      if (result === '从剪切板添加到NAS') {
        openShortCutPage(URL_CLIPBOARD_TO_NAS);
      }
    };
    onMounted(async () => {
      document.title = '添加下载链接';
      const query = Object.assign({}, router.currentRoute.value.query);
      // console.log('routequery', query)
      if (query.taskLink) {
        if (Array.isArray(query.taskLink)) {
          uploadUrls.value = query.taskLink.join('\n');
        } else {
          uploadUrls.value = String(query.taskLink);
        }
        delete query.taskLink;
        hasTaskLink.value = true;
        router.replace({
          query
        });
      }
      try {
        isSupportBEncode.value = checkWebWorkerCompatibility();
      } catch (error) {
        console.log(error);
      }
      stat({
        action: 'new_create_panel_show',
        data: {
          action_from: createFrom.value
        }
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [showHeader.value ? (_openBlock(), _createBlock(PageHeader, {
        key: 0,
        title: "添加下载链接",
        onBack: handleBack
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => uploadUrls.value = $event),
        class: "textarea__inner",
        placeholder: "请添加下载链接，批量链接请换行，最多支持一次添加50个链接。暂不支持本地BT文件和下载链接一起添加",
        onInput: _cache[1] || (_cache[1] = $event => error.value = '')
      }, null, 544), [[_vModelText, uploadUrls.value]]), showUploadBT.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "textarea__upload",
        onClick: _cache[4] || (_cache[4] = $event => _unref(toggleBTFileMenuShow)(true))
      }, [_hoisted_4, _createTextVNode("添加BT文件 "), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => {
          handleUploadBT();
          _unref(toggleBTFileMenuShow)(false);
        }, ["stop"]))
      }, " 从本地选择 "), _createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => {
          resolveBTFromDevice();
          _unref(toggleBTFileMenuShow)(false);
        }, ["stop"]))
      }, " 从NAS设备选择 ")])], 512), [[_vShow, _unref(isBTFileMenuShow)]])])) : _createCommentVNode("", true), _createElementVNode("input", {
        id: "upload",
        ref_key: "uploadInput",
        ref: uploadInput,
        class: "textarea__input",
        type: "file",
        onChange: resolveBtTask
      }, null, 544), error.value ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1)) : _createCommentVNode("", true)])]), !isSupportBEncode.value ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 检测到浏览器版本过低，添加本地BT文件功能可能无法正常使用 ")) : _createCommentVNode("", true), _unref(envStore).justOne !== '1' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "device-confirm",
        onClick: onDeviceListClick
      }, [_hoisted_8, _createVNode(DeviceIndicator), _createVNode(_unref(IconPageLeft), {
        width: "16",
        height: "16"
      })])) : _createCommentVNode("", true), _createElementVNode("a", {
        class: _normalizeClass(["file-upload__button", {
          disabled: uploadUrls.value.length < 5
        }]),
        href: "javascript:;",
        onClick: onUpload
      }, "确定", 2), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("i", {
        class: "qh-icon-close",
        onClick: _cache[5] || (_cache[5] = $event => isLoading.value = false)
      }), _hoisted_11, _hoisted_12])], 512), [[_vShow, isLoading.value]]), visiblePathChoose.value ? (_openBlock(), _createBlock(PathChoicePop, {
        key: 3
      })) : _createCommentVNode("", true), _unref(platformPath) === '' && _unref(isIOS) ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "add-shortcut",
        onClick: addShortcut
      }, [_createElementVNode("img", {
        src: _unref(Shortcut),
        alt: "添加捷径"
      }, null, 8, _hoisted_13), _createTextVNode(" 添加快捷指令 ")])) : _createCommentVNode("", true)]);
    };
  }
});